import { PrimaryButton } from './ui';

export default function StaticPage({ content, showStats = false }) {
  return (
    <main id="contenido" className="static-page">
      <section className="static-page__hero">
        <div className="shell static-page__hero-inner">
          <p className="eyebrow">{content.eyebrow}</p>
          <h1>{content.title}</h1>
          <p className="static-page__lead">{content.lead}</p>
        </div>
      </section>

      <section className="static-page__body">
        <div className="shell static-page__content">
          {content.sections.map((section) => (
            <article key={section.title} className="static-page__section">
              <h2>{section.title}</h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph.slice(0, 40)}>{paragraph}</p>
              ))}
              {section.list ? (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </article>
          ))}

          {showStats && content.stats ? (
            <div className="static-page__stats">
              {content.stats.map((stat) => (
                <div key={stat.label} className="cta-stat">
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>
          ) : null}

          {content.ctaTitle ? (
            <aside className="static-page__cta">
              <h2>{content.ctaTitle}</h2>
              <p>{content.ctaCopy}</p>
              <PrimaryButton to="/#contacto">{content.ctaButton}</PrimaryButton>
            </aside>
          ) : null}
        </div>
      </section>
    </main>
  );
}
